<template>
    <v-app-bar
            app
            light
            :clipped-left="$vuetify.breakpoint.lgAndUp"
    >

        <v-toolbar-title></v-toolbar-title>
        <v-progress-linear
                :active="isLoading"
                :indeterminate="isLoading"
                absolute
                top
                height="5"
                background-color="blue"
                color="red accent-4"
        ></v-progress-linear>
        <img src="../../assets/systematix-logo-min.png" height="20px"  />

        <v-spacer></v-spacer>
        <v-menu left offset-y>
            <template v-slot:activator="{ on, attrs }">
                <v-btn

                        icon
                        v-bind="attrs"
                        v-on="on"
                >
                    <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
            </template>
            <v-list>
                <v-list-item @click="logout">

                    <v-list-item-icon>
                        <v-icon>mdi-logout</v-icon>
                    </v-list-item-icon>

                    <v-list-item-title>Logout</v-list-item-title>

                </v-list-item>
                <v-list-item :to="{name: 'profile'}">
                    <v-list-item-icon>
                        <v-icon>mdi-account</v-icon>
                    </v-list-item-icon>

                    <v-list-item-title>My Profile</v-list-item-title>

                </v-list-item>
            </v-list>
        </v-menu>
    </v-app-bar>
</template>

<script>
    import Clean from "../../layouts/Clean";
    import {mapGetters} from "vuex";

    export default {
        props: {

        },
        data: () => ({
            loading: false
        }),
        computed: {
            ...mapGetters('notification', [
                'isLoading',
            ]),
        },
        methods: {
            // Log the user in
            login() {
                this.$auth.loginWithRedirect();
            },
            // Log the user out
            logout() {
                this.$store.dispatch('auth/logout')
                this.$emit('update:layout', Clean)
                this.$router.push({name:'login'})
            }
        }
    };
</script>
